import { useEffect, useState } from "react";
import { api, API } from "./api";

let cache = null;

export const siteImg = (id) => `${API}/public/site-images/${id}`;
export const siteText = (s, k, lang, fallback) => s?.texts?.[k]?.[lang] || fallback;
export const isPreview = () => new URLSearchParams(window.location.search).get("preview") === "draft";

export function useSite() {
  const preview = isPreview();
  const [site, setSite] = useState(preview ? null : cache);
  useEffect(() => {
    const pub = () => api.get("/public/site").then((r) => { cache = r.data; return r.data; });
    (preview ? api.get("/admin/site").then((r) => r.data.draft).catch(pub) : pub()).then(setSite).catch(() => setSite({}));
  }, [preview]);
  return site;
}
